import React from 'react'
import IconAccreditation from '../../icons/IconAccreditation/IconAccreditation'

const Accreditation = ({
  accreditation
}: {
  accreditation: string
}): JSX.Element => {
  return (
    <span className="flex flex-row items-center gap-x-1.5 text-xs">
      <IconAccreditation />{' '}
      <span className="pt-[2px] text-[11px] font-medium leading-[11px] text-gray-800 md:pt-0">
        {accreditation} Accredited
      </span>
    </span>
  )
}

export default Accreditation
